import { XClose } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';
import CommonModal from 'src/components/CommonModal';

interface IProps {
    handleClose: () => void;
    videoUrl?: string;
    videoTitle?: string;
}

const WatchVideoModal = ({ handleClose, videoUrl, videoTitle }: IProps) => (
    <CommonModal handleClose={handleClose} size={'max-w-[1000px]'} isOverflow={true} modalClassName="">
        <div className="youtube-embed">
            <div
                className={`cursor-pointer [&>svg]:w-4 [&>svg]:text-grayLight600 bg-white transition-all duration-300 h-8 w-8 flex justify-center items-center rounded-full flex-none shadow-md absolute top-4 right-4 hover:shadow-xl`}
                onClick={handleClose}
            >
                <XClose className="text-gray400 hover:text-textSecondary" />
            </div>
            <iframe
                width="100%"
                height="570"
                src={videoUrl || 'https://www.youtube.com/embed/N6ei3iMZzaw'}
                title={videoTitle || 'Platform Overview'}
                style={{ border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
            ></iframe>
        </div>
    </CommonModal>
);

export default WatchVideoModal;
